import {
  FilePlaceholder,
  JpgPlaceholder,
  PdfPlaceholder,
  PngPlaceholder,
  TxtPlaceholder,
} from "icons/index";
import { atobPolyfill } from "utils";

export const localTicket = {
  id: "500Hr00001oI7dnIAC",
  number: "00055831",
  title: "Conta Olist",
  order_number: null,
  product: "",
  created_at: "2024-11-29T22:09:30.000+0000",
  updated_at: "2024-11-29T22:52:32.000+0000",
  status: "fechado",
  priority: "média",
  opened_by: "005Hr00000FJOBcIAP",
  discussion: [
    {
      id: "0D5Hr00007lJ25HKAS",
      date: "2024-11-29T22:09:34.000Z",
      body: [
        {
          text: "Olá, Gustavo\n\nObrigado por entrar em contato conosco. Sua solicitação de número 00055831 foi\n\nrecebida pelo nosso time de Loja. Em até 24h úteis, retomaremos o contato.\n\nPara acrescentar um comentário ou uma nova informação, é só responder esta mensagem.\n\nObrigado,\n\nTime de Atendimento de Olist Loja",
          type: "text",
        },
      ],
      attachments: [],
      sent_by: "support",
    },
  ],
  contact_email: "suporte@olist.com",
  attachments: [],
  description: "olá",
};

export const productToName = {
  envios: "Envios",
  store: "Loja",
  tiny: "Sistema ERP",
  // conta_digital: "Olist Conta Digital",
};

export const statutsFiltersDictionary = {
  novo: {
    label: "Aberto",
    variation: "info",
  },
  aberto: {
    label: "Aberto",
    variation: "info",
  },
  pendente: {
    label: "Aguardando sua resposta",
    variation: "alert",
  },
  escalado: {
    label: "Aberto",
    variation: "info",
  },
  concluído: {
    label: "Finalizado",
    variation: "success",
  },
  fechado: {
    label: "Finalizado",
    variation: "success",
  },
  resolvido: {
    label: "Finalizado",
    variation: "success",
  },
};

export function convertNewlinesToHtml(text) {
  if (typeof text !== "string") return "";

  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;

  return text
    .replace(urlRegex, (url) => {
      const href = url.startsWith("http") ? url : `http://${url}`;
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    })
    .replaceAll("\n\n\n", "\n\n")
    .replaceAll("\n\n\n\n", "\n\n")
    .split("\n")
    .map((line) => (line.trim() === "" ? "<br>" : line))
    .join("<br>");
}

function base64ToUint8Array(base64Input: string) {
  const base64 = base64Input.replace(/\s/g, "").replace(/^data:.*;base64,/, "");

  if (typeof Buffer !== "undefined") {
    return new Uint8Array(Buffer.from(base64, "base64"));
  }

  const raw = atobPolyfill(base64);
  const outputArray = new Uint8Array(raw.length);
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < raw.length; i++) {
    outputArray[i] = raw.charCodeAt(i);
  }
  return outputArray;
}

export async function downloadBase64Image(
  base64Data,
  filename = "downloaded_image.png",
  mimeType = "image/png"
) {
  const byteArray = await base64ToUint8Array(base64Data);

  const blob = new Blob([byteArray], { type: mimeType });

  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);

  URL.revokeObjectURL(blobUrl);
}

export const imageMimetypes = [
  "image/png",
  "image/jpg",
  "image/jpeg",
  "image/webp",
];

export const mimetypeToPlaceholder = {
  "application/pdf": PdfPlaceholder,
  "text/plain": TxtPlaceholder,
  "application/octet-stream": TxtPlaceholder,
  "image/png": PngPlaceholder,
  "image/jpg": JpgPlaceholder,
  "image/jpeg": JpgPlaceholder,
  default: FilePlaceholder,
};
